var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-autocomplete',{attrs:{"dense":"","outlined":"","value":_vm.value,"items":_vm.contextTypes,"label":_vm.label,"hide-details":""},on:{"change":function($event){return _vm.$emit('input', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }